import { Button, Colors, Display, Sizes } from "../Button/Button"
import { BillingEmailField } from "./Gibs/BillingEmailField"
import { PaymentMethodField } from "./Gibs/PaymentMethodField"
import alertToast from "Util/ToastifyUtils";
import { OrganisationEntity } from "Models/Entities";
import { deleteBusinessPaymentMethod } from "Hooks/Api/apiStripe";
import InlineSpinner from "../Spinner/InlineSpinner";
import { useApiBusinessPaymentMethod } from "Hooks/ApiHooks/useApiBusiness";

export type Props = {
	isOrganisation?: boolean;
	organisation: OrganisationEntity;
	businessEntityId: string;
}

const TEXT_BUSINESS_PAYMENT_DETAILS = "By providing a payment method at the business-entity level, your business entity will be charged for purchasing credit reports upfront using its stored payment details rather than the organisation's default method.";

export const BusinessEntityPaymentDetailsFields = ({ organisation, businessEntityId, isOrganisation }: Props) => {
	const {
		data: businessPaymentMethod,
		type: reqBusinessPaymentMethodStatus,
		refresh: refreshBusinessPaymentMethod
	} = useApiBusinessPaymentMethod(businessEntityId);

	if (reqBusinessPaymentMethodStatus === 'loading' || reqBusinessPaymentMethodStatus === 'error') return <InlineSpinner />;

	const removePaymentMethod = async () => {
		if (businessPaymentMethod == null) return;
		const response = await deleteBusinessPaymentMethod(businessPaymentMethod.id);
		if (response.status === 200) alertToast('Successfully removed payment method', 'success');
		else alertToast('Failed to remove payment method', 'error');
		refreshBusinessPaymentMethod();
	}

	const finalTitle = isOrganisation ? "Primary payment method (organisation-level)" : "Business entity payment details";
	return (
		<div className="container">
			<div className="title">
				<h4>{finalTitle}</h4>
				<div className="actions">
					{businessPaymentMethod && (
						<Button
							display={Display.Outline}
							sizes={Sizes.Small}
							colors={Colors.Error}
							onClick={() => removePaymentMethod()}
						>
							Remove Method
						</Button>
					)}

				</div>
			</div>
			{!isOrganisation && <p>{TEXT_BUSINESS_PAYMENT_DETAILS}</p>}

			<div className="billing-fields">
				<PaymentMethodField
					paymentMethodDetails={businessPaymentMethod}
					organisation={organisation}
					businessEntityId={businessEntityId}
				/>

				{businessPaymentMethod?.billingEmail && (
					<BillingEmailField email={businessPaymentMethod.billingEmail} />
				)}
			</div>
		</div>
	)
}
